module.exports = __webpack_public_path__ + "img/ziak.60756fc8.svg";